import { removeItemByIndex } from '@/core/utils/arrays';
import { useItemWorkflowTableStore } from '@/warehouse/components/ItemWorkflowTable/business';
/**
 * Removes the specified item from an {@link ItemWorkflowVirtualizedTable}.
 *
 * Also it adjusts manually selected by warehouseman *current item index* in case if the item was removed above the
 * selection, so that the selection still stands on the same item with the same id, preventing occasional
 * action mistakes.
 */
export function removeItemFromWorkflowTable(array, index) {
    removeItemByIndex(array, index);
    useItemWorkflowTableStore.getState().adjustCurrentItemIndex({ removedItemIndex: index });
}
